module.exports = __webpack_public_path__ + "static/sec2-6dff8f7d3983e2de93580abef4cc238f.png";